/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { Role } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface RolesServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Creates new role
     * This endpoint is used to create a new role
     * @param role Role object to be created
     */
    createRole(role: Role, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Delete the role
     * Delete the role specified id
     * @param roleId The id of the role to delete.
     */
    deleteRole(roleId: number, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Get role
     * Returns the role by id
     * @param roleId The id of the role to fetch.
     */
    getRoleById(roleId: number, extraHttpRequestParams?: any): Observable<Role>;

    /**
     * Get all roles
     * Returns a list of roles.
     */
    getRoles(extraHttpRequestParams?: any): Observable<Array<Role>>;

    /**
     * Update role
     * Update the role with the specified id
     * @param roleId The id of the role to update.
     * @param role The updated role
     */
    updateRole(roleId: number, role: Role, extraHttpRequestParams?: any): Observable<{}>;

}
